export default __webpack_public_path__ + "static/media/izquierda.153436a7.png";